// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1cZy4","type":"styles_type__1NLhs","choices":"styles_choices__qAXdg"};